import * as Yup from "yup";
import { useFormik } from "formik";


export const generateValidationSchema = (structure: any) => {
  const shape: any = {};
  structure.forEach((field: any) => {
    let validator = field.type === 'number' ? Yup.number() : Yup.string();

    if (field.validators.required) {
      validator = validator.required('Este campo es requerido');
    }

    if (field.validators.minLength) {
      validator = validator.min(field.validators.minLength, `Debe tener al menos ${field.validators.minLength} caracteres`);
    }

    if (field.validators.maxLength) {
      validator = validator.max(field.validators.maxLength, `Debe tener máximo ${field.validators.maxLength} caracteres`);
    }

    if (field.type === 'number' && field.validators.maxLength) {
      validator = validator.max(field.validators.maxLength, `El valor no puede ser mayor a  ${field.validators.maxLength}`);
    }

    if (field.type === 'number' && field.validators.minLength) {
      validator = validator.min(field.validators.minLength, `La valor no puede ser menor a ${field.validators.minLength}`);
    }

    shape[field.key] = validator;
  });

  return Yup.object().shape(shape);
};

const useDynamicForm = ({ structure, onSubmit }: any) => {
  const initialValues = structure.reduce((acc: any, field: any) => {
    acc[field.key] = field.value ?? '';
    return acc;
  }, {});

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: generateValidationSchema(structure),
    onSubmit: onSubmit,
  });

  return { formik };
}


export default useDynamicForm;

